import { CONTACT_CENTER_EMAIL } from 'utils/constants';

import phone from 'assets/icons/phone.png';
import letter from 'assets/icons/letter.png';
import location from 'assets/icons/location.png';

const content = [
  {
    header: 'Head Office',
    contacts: [
      {
        type: 'location',
        icon: location,
        text: 'Atlantic Place, No. 1 Seventh Avenue, Ridge West, Accra, Ghana',
      },
      {
        type: 'phone',
        icon: phone,
        text: '0302904459',
      },
      {
        type: 'phone',
        icon: phone,
        text: '0302218040',
      },
      {
        type: 'phone',
        icon: phone,
        text: '0302679253',
      },
    ],
  },
  {
    header: 'Contact Center',
    contacts: [
      {
        type: 'email',
        icon: letter,
        text: CONTACT_CENTER_EMAIL,
      },
      {
        type: 'phone',
        icon: phone,
        text: '0302904459',
      },
      {
        type: 'phone',
        icon: phone,
        text: '0302218040',
      },
      {
        type: 'phone',
        icon: phone,
        text: '0302679253',
      },
    ],
  },
];

export default content;
